import React from 'react'
import PropTypes from 'prop-types'
import RegisteredFormField from '../../../common/RegisteredFormField'

const CurrencyInput = ({ id, label, path, disabled }) => {
  return <RegisteredFormField
    id={id}
    path={path}
    attachedLabel='$'
    label={label}
    disabled={disabled}
  />
}

CurrencyInput.propTypes = {
  /** A unique element ID */
  id: PropTypes.string,
  /** A label for the form field */
  label: PropTypes.node,
  /** The redux object full path for this form field */
  path: PropTypes.string.isRequired,
  /** A currency-masked form field can be disabled via the parent */
  disabled: PropTypes.bool
}

export default CurrencyInput